export default __webpack_public_path__ + "static/azuki-1cd3061eb2042a3119e47f785e489e74.png";